import { ConfirmResult } from "../enums";
import { RydeUiUnit } from "./common.models";

export type SoftValidationErrorAdditionalValues = number | string | object;

export interface ISoftValidationErrorBase<
  T = any,
  B extends number | string = any,
> {
  type: T;
  message: string;
  additional?: Partial<Record<B, SoftValidationErrorAdditionalValues>>;
}

export interface ISoftValidationErrorBaseResponse<
  T = any,
  B extends number | string = any,
> {
  validationErrors: ISoftValidationErrorBase<T, B>[];
  token: string;
  entity: RydeUiUnit;
  isSoftValidation: boolean;
}

export interface IBulkSoftValidationItemErrorBase<
  T,
  B extends number | string,
> {
  validationErrors: ISoftValidationErrorBase<T, B>[];
  itemId: number;
  entity: RydeUiUnit;
}

export interface IBulkSoftValidationErrorBaseResponse<
  T = any,
  B extends number | string = any,
> {
  items: IBulkSoftValidationItemErrorBase<T, B>[];
  token: string;
  isSoftValidation: boolean;
}

export type ISoftValidationModalPayloadData =
  IBulkSoftValidationErrorBaseResponse | ISoftValidationErrorBaseResponse;

export interface ISoftValidationModalPayload {
  resolveFn: (result: ConfirmResult) => void;
  data: ISoftValidationModalPayloadData;
}

export const isSoftValidationBulkErrorResponse = <T, B extends number | string>(
  value: unknown,
): value is IBulkSoftValidationErrorBaseResponse<T, B> => {
  return (
    value !== null &&
    typeof value === "object" &&
    "items" in value &&
    "isSoftValidation" in value &&
    value.isSoftValidation === true
  );
};

export const isHardSoftValidationBulkErrorResponse = <
  T,
  B extends number | string,
>(
  value: unknown,
): value is IBulkSoftValidationErrorBaseResponse<T, B> => {
  return (
    value !== null &&
    typeof value === "object" &&
    "items" in value &&
    "isSoftValidation" in value &&
    value.isSoftValidation === false
  );
};

export const isSoftValidationSingleErrorResponse = <
  T,
  B extends number | string,
>(
  value: unknown,
): value is ISoftValidationErrorBaseResponse<T, B> => {
  return (
    value !== null &&
    typeof value === "object" &&
    "validationErrors" in value &&
    "isSoftValidation" in value &&
    value.isSoftValidation === true
  );
};

export const isSoftHardValidationSingleErrorResponse = <
  T,
  B extends number | string,
>(
  value: unknown,
): value is ISoftValidationErrorBaseResponse<T, B> => {
  return (
    value !== null &&
    typeof value === "object" &&
    "validationErrors" in value &&
    "isSoftValidation" in value &&
    value.isSoftValidation === false
  );
};
